import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = true
application.warnings = true

export { application }
